import(/* webpackMode: "eager", webpackExports: ["BaseLayout"] */ "/workspace/app-site/src/components/baseLayout/BaseLayout.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/app-site/styles/globals.scss");
